<template>
  <div
    class="col-12 w-xxl-500px w-xl-500px w-lg-500px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
  >
    <form class="form w-100" @submit.prevent="handleLogin">
      <div class="text-center mb-10">
        <h1 class="text-dark mb-3">Entrar</h1>
        <h2 v-if="this.tempoBloqueio > 0" class="text-danger mb-3">
          {{ "Tempo restante: " + this.contagemRegressiva }}
        </h2>
      </div>
      <div class="fv-row mb-10">
        <label class="form-label fs-6 fw-bolder text-dark">Email</label>
        <input
          id="txtLogin"
          class="form-control form-control-lg form-control-solid"
          type="text"
          v-model="form.login"
        />
      </div>
      <div class="fv-row mb-10">
        <div class="d-flex flex-stack mb-2">
          <label class="form-label fw-bolder text-dark fs-6 mb-0">Senha</label>
          <router-link
            :to="{
              path: '/password-reset',
              query: { email: this.form.login },
            }"
            class="link-primary fs-6 fw-bolder"
          >
            Esqueceu a sua senha?
          </router-link>
        </div>
        <input
          id="txtPassword"
          class="form-control form-control-lg form-control-solid"
          type="password"
          v-model="form.password"
        />
      </div>
      <div class="fv-row mb-10">
        <div class="d-flex flex-stack mb-2">
          <div
            class="form-check form-switch form-check-custom form-check-solid"
          >
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexSwitchChecked"
              :checked="form.lembrarMe"
            />
            <label class="form-check-label" for="flexSwitchChecked"
              >Lembrar-me</label
            >
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center fv-row mb-10">
        <vue-recaptcha
          v-show="exibirRecaptcha"
          :sitekey="this.keyReCaptcha"
          size="normal"
          theme="light"
          hl="pt-br"
          :loading-timeout="loadingTimeout"
          @verify="recaptchaVerified"
          @expire="recaptchaExpired"
          @fail="recaptchaFailed"
          @error="recaptchaError"
          ref="vueRecaptcha"
        >
        </vue-recaptcha>
      </div>
      <div class="text-center">
        <button
          id="kt_sign_in_submit"
          class="btn btn-lg btn-primary w-100 mb-5"
          v-bind:data-kt-indicator="loading ? 'on' : 'off'"
        >
          <span class="indicator-label"> Continuar </span>

          <span class="indicator-progress">
            Aguarde...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>
      </div>
    </form>
    <div class="text-center" v-if="this.exibirRegistroGratuito">
      <router-link
        to="/register"
        id="kt_register"
        class="btn btn-lg btn-light-primary w-100 mb-5"
      >
        Registre-se gratuitamente
      </router-link>
    </div>
  </div>
  <SessaoUsuariosModal
    v-if="exibirSessaoUsuarios"
    :user="this.usuario"
    @exibirModalSessaoUsuarios="modalSessaoUsuarios"
  ></SessaoUsuariosModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import vueRecaptcha from "vue3-recaptcha2";
import recaptchaConfig from "@/recaptcha.json";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import SessaoUsuariosModal from "@/views/sessaousuarios/SessaoUsuariosModal.vue";
import hubConnection from "@/utils/signalrHub";

export default {
  name: "Sign-in",
  components: { vueRecaptcha, SessaoUsuariosModal },
  data: () => ({
    exibirSessaoUsuarios: false,
    usuario: null,
    tempoBloqueio: 0,
    intervaloAtualizacao: null,
    contagemRegressiva: "",
    codeRecaptcha: "",
    loadingTimeout: 30000, // 30 seconds
    exibirRecaptcha: false,
    tentativas: 0,
    exibirRegistroGratuito: false,
    keyReCaptcha: recaptchaConfig.keyReCaptcha,
    form: {
      login: "",
      password: "",
      lembrarMe: true,
    },
    loading: false,
    message: "",
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  async created() {
    // if (this.loggedIn) {
    //   this.$router.push("/dashboard");
    // }
  },
  mounted() {
    this.tentativas = 0;
    this.codeRecaptcha = "";
    if (localStorage.getItem("loginApp")) {
      try {
        this.form = JSON.parse(localStorage.getItem("loginApp"));
      } catch (error) {
        localStorage.removeItem("loginApp");
      }
    }
  },
  methods: {
    modalSessaoUsuarios(exibir) {
      this.exibirSessaoUsuarios = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_sessao_usuarios_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarSessaoUsuarios");
          },
          /*close*/ () => {
            this.modalSessaoUsuarios(false);
          }
        );
      }
    },
    recaptchaVerified(response) {
      this.codeRecaptcha = response;
    },
    recaptchaExpired() {
      this.recaptchaReset();
    },
    recaptchaFailed() {
      this.codeRecaptcha = "";
    },
    recaptchaError(reason) {
      console.log(reason);
      this.codeRecaptcha = "";
    },
    recaptchaReset() {
      this.$refs.vueRecaptcha.reset();
      this.codeRecaptcha = "";
    },
    async handleLogin() {
      this.message = "";
      this.usuario = null;
      clearInterval(this.intervaloAtualizacao);
      this.tempoBloqueio = 0;
      if ((await this.validar()) === true) {
        this.loading = true;
        try {
          var loginViewModel = {
            Login: this.form.login,
            Password: this.form.password,
            LembrarMe: this.form.lembrarMe,
            SessaoUsuario: {
              session_id: "Terminal",
              tipo_dispositivo: this.$utils.retornarTipoDispositivo(),
              sistema_operacional:
                await this.$utils.retornarSistemaOperacional(),
              navegador: this.$utils.retornarNavegador(),
              ip: await this.$utils.consultarIpExterno(),
            },
          };
          var ret = await this.$store.dispatch("auth/login", loginViewModel);
          if (ret.User !== null) {
            hubConnection.connection.invoke(
              "ConectarUsuario",
              ret.RefreshToken,
              ret.User.id
            );
            await this.$store.dispatch("menu/desmontarMenu");
            this.$router.push("/dashboard");
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            if (this.tentativas < 3) {
              this.tentativas += 1;
              this.message =
                "A combinação de login e senha está incorreta! Tentativas restantes: " +
                (4 - this.tentativas);
            } else {
              this.message =
                "Atenção! Várias tentativas de login podem bloquear o acesso ao sistema neste computador/dispositivo!";
            }
          } else if (
            error.response &&
            error.response.data &&
            error.response.status === 403
          ) {
            if (error.response.data.Data.User) {
              this.usuario = error.response.data.Data.User;
              if (
                this.usuario.EmitenteTipoUsuario.EmitenteRestricao.find(
                  (modulo) => modulo.regra == "Permitir.SessaoUsuario.Consultar"
                )
              ) {
                await this.$swal.showCustomAlert(
                  error.response.data.Message,
                  "warning",
                  "Usuários Conectados",
                  "Sair",
                  (alert) => {
                    if (alert.isConfirmed) {
                      this.modalSessaoUsuarios(true);
                    }
                  }
                );
              } else {
                var text =
                  error.response.data.Message +
                  " Por favor solicite ao responsável para verificar os usuários conectados!";
                await this.$swal.showInvalidAlert(text);
              }
            } else {
              this.message = error.response.data.Message;
              this.tempoBloqueio = error.response.data.Data;
              this.intervaloAtualizacao = setInterval(() => {
                this.atualizarContagemRegressiva();
              }, 1000);
            }
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.Message
          ) {
            this.message = error.response.data.Message;
          } else if (error.response && error.response.data) {
            this.message = error.response.data;
          } else if (error.message) {
            this.message = error.message;
          } else {
            error.toString();
          }

          if (this.message != "") {
            await this.$swal.showErrorAlert(
              this.message.replace(/\r\n/g, "<br>")
            );
          }

          if (this.tentativas >= 3) {
            this.exibirRecaptcha = true;
            this.recaptchaReset();
          }
        }
        this.loading = false;
      }
    },
    async validar() {
      var result = true;
      if (this.exibirRecaptcha === true) {
        try {
          var ret = await this.$store.dispatch(
            "recaptcha/postRecaptchaValidate",
            { Response: this.codeRecaptcha }
          );
          if (ret.Success === false) {
            await this.$swal.showErrorAlert(
              "Erro na Validação do Recaptcha!",
              (alert) => {
                this.recaptchaReset();
                result = false;
              }
            );
          }
        } catch (error) {
          await this.$swal.showErrorAlert(
            "Erro na Validação do Recaptcha!",
            (alert) => {
              this.recaptchaReset();
              result = false;
            }
          );
        }
      }

      if (this.$utils.checkEmail(this.form.login) === true) {
        await this.$swal.showInvalidAlert(
          "O e-mail informado é inválido!",
          (alert) => {
            this.$utils.requestFocus("txtLogin");
            result = false;
          }
        );
      }

      if (this.form.password === "") {
        await this.$swal.showInvalidAlert(
          "A senha informada é inválida!",
          (alert) => {
            this.$utils.requestFocus("txtPassword");
            result = false;
          }
        );
      }

      return result;
    },
    atualizarContagemRegressiva() {
      let dataAtual = new Date(0, 0, 0, 0, 0, this.tempoBloqueio);
      let horas = dataAtual.getHours();
      let minutos = dataAtual.getMinutes();
      let segundos = dataAtual.getSeconds();

      let horasFormatadas = horas < 10 ? "0" + horas : horas;
      let minutosFormatados = minutos < 10 ? "0" + minutos : minutos;
      let segundosFormatados = segundos < 10 ? "0" + segundos : segundos;

      this.contagemRegressiva = `${horasFormatadas}:${minutosFormatados}:${segundosFormatados}`;

      this.tempoBloqueio--;

      if (this.tempoBloqueio <= 0) {
        clearInterval(this.intervaloAtualizacao);
        console.log("Tempo expirado!");
      }
    },
  },
};
</script>
